import { HttpClient, HttpHeaders } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { JsonConvert } from "json2typescript";
import { Observable } from "rxjs";

import { PersistRequest, PersistResponse } from "@hermes/api-model-basket";
import { LOCALE, Settings } from "@hermes/core-app-core";

import { HTTP_JSON_CONTENT_TYPE_HEADER } from "@hermes/utils-generic-constants";

@Injectable()
export class BasketService {
    readonly #http = inject(HttpClient);
    readonly #settings = inject(Settings);
    readonly #locale = inject(LOCALE);

    public persist(
        persistRequest: PersistRequest,
    ): Observable<PersistResponse> {
        persistRequest.locale = this.#locale.code;
        return this.#http.post<PersistResponse>(
            `${this.#settings.apiUrl}/basket/persist`,
            new JsonConvert().serializeObject(persistRequest),
            {
                headers: new HttpHeaders({
                    ...HTTP_JSON_CONTENT_TYPE_HEADER,
                }),
            },
        );
    }
}
